module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "homepage"
  }, [_c('div', {
    staticClass: "homesection top"
  }, [_c('div', {
    staticClass: "dimmer"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (.3),
      expression: ".3"
    }],
    staticClass: "intro"
  }, [_c('h1', [_vm._v(_vm._s(_vm.plCount) + " locations ready for filming")]), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "search-inner"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icon.svg")
    }
  }), _vm._v(" "), _c('Autocomplete', {
    attrs: {
      "searchPlaceholder": _vm.searchPlaceholder,
      "styling": 'home'
    },
    on: {
      "searchFocus": function($event) {
        _vm.showTyper = false, _vm.searchPlaceholder = "Search... "
      },
      "select": _vm.searchSelect
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("search")]), _vm._v(" "), (_vm.showTyper) ? _c('vue-typer', {
    attrs: {
      "text": ["Loft", "Bar", "Rooftop", "Garage", "Pool", "Victorian", "Mid-century", "Downtown", "Beachfront", "Industrial"],
      "erase-style": "clear",
      "initial-action": "typing",
      "shuffle": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('router-link', {
    staticClass: "advanced-search",
    attrs: {
      "to": '/browse'
    }
  }, [_vm._v("Advanced Search")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "parallax-cutter"
  }, [_c('div', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (.5),
      expression: ".5"
    }],
    staticClass: "parallax-container"
  }, [_c('img', {
    attrs: {
      "src": 'https://img.productionlocations.com/' + _vm.sitecontent.homepage.top
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "browse-section"
  }, [_c('h2', [_c('router-link', {
    attrs: {
      "to": '/browse'
    }
  }, [_vm._v("Browse Locations")])], 1), _vm._v(" "), _c('div', {
    staticClass: "featured-tags"
  }, [_vm._l((_vm.sitecontent.featuredtags), function(featuredTag) {
    return _c('div', {
      staticClass: "featured-tag"
    }, [_c('router-link', {
      attrs: {
        "to": '/browse/' + featuredTag.slug
      }
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": 'https://img.productionlocations.com/' + featuredTag.url
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "overlay"
    }, [_c('p', {
      staticClass: "name",
      domProps: {
        "textContent": _vm._s(featuredTag.name)
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "plcount",
      domProps: {
        "textContent": _vm._s(featuredTag.plcount + ' Locations')
      }
    })])])], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "featured-tag see-all"
  }, [_c('router-link', {
    attrs: {
      "to": '/browse/'
    }
  }, [_c('span', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("arrow_forward")]), _vm._v("\n              All Categories\n            ")])])], 1)], 2)]), _vm._v(" "), _c('div', {
    staticClass: "homesection second"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (.5),
      expression: ".5"
    }],
    staticClass: "parallax-container"
  }, [_c('img', {
    attrs: {
      "src": 'https://img.productionlocations.com/' + _vm.sitecontent.homepage.middle
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "homesection fourth"
  }, [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Start your search today"), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/browse'
    }
  }, [_vm._v("Browse Locations")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (.5),
      expression: ".5"
    }],
    staticClass: "parallax-container"
  }, [_c('img', {
    attrs: {
      "src": 'https://img.productionlocations.com/' + _vm.sitecontent.homepage.bottom
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-yellow"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headline"
  }, [_vm._v("Commercial, residential, industrial, and "), _c('b', [_vm._v("everything")]), _vm._v(" in between")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-246bbd84","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 183
// module chunks = 1